import { IJob, ILeg } from "@/types";

export const generateLeg = (form: any, editableLegs: ILeg[]) => {
  const newLeg: ILeg = {
    _id: form._id || "",
    client: form.client || null,
    jobId: form.jobId || "",
    driver: form.driver || null,
    appointmentDate: form.appointmentDate || null,
    orderNumber: form.orderNumber || "",
    loadNumber: form.loadNumber || "",
    loadType: form.loadType || "Regular",
    weight: form.weight || 0,
    route: {
      _id: form.route?._id || "",
      origin: {
        _id: form.route?.origin?._id || "",
        address: {
          _id: form.route?.origin?.address?._id || "",
          street: form.route?.origin?.address?.street || "",
          city: form.route?.origin?.address?.city || "",
          state: form.route?.origin?.address?.state || "",
          zipcode: form.route?.origin?.address?.zipcode || "",
          fullAddress: form.route?.origin?.address?.fullAddress || "",
        },
      },
      destination: {
        _id: form.route?.destination?._id || "",
        address: {
          _id: form.route?.destination?.address?._id || "",
          street: form.route?.destination?.address?.street || "",
          city: form.route?.destination?.address?.city || "",
          state: form.route?.destination?.address?.state || "",
          zipcode: form.route?.destination?.address?.zipcode || "",
          fullAddress: form.route?.destination?.address?.fullAddress || "",
        },
      },
      mileage: form.route?.mileage || 0,
    },
    waitTime: { total: form.waitTime?.total || 0 },
    terminationDate: form.terminationDate || "",
    payoutSupplemental: form.payoutSupplemental || 0,
    payoutType: form.payoutType || "Mileage",
    payoutId: form.payoutId || null,
    mileageRate: form.mileageRate || 0,
    payoutRate: form.payoutRate || 0,
    emptyRate: form.emptyRate || 0,
    hourlyRate: form.hourlyRate || 0,
    useCustomPayoutRate: form.useCustomPayoutRate || false,
    useCustomPayoutSupplemental: form.useCustomPayoutSupplemental || false,
    manifestId: form.manifestId || null,
    customManifestMileage: form.customManifestMileage || 0,
    useCustomManifestMileage: form.useCustomManifestMileage || false,
    sortKey: form.sortKey || 0,
    hasHandoff: form.hasHandoff || false,
    isHandoff: form.isHandoff || false,
    handoff: form.handoff || "",
    handoffParent: form.handoffParent || "",
    useLegFlatRate: form.useLegFlatRate || false,
    accessories: form.accessories || [],
    accessoriesTotal: form.accessoriesTotal || 0,
    baseCharge: form.baseCharge || 0,
    otherCharges: form.otherCharges || 0,
    fuelSurcharge: form.fuelSurcharge || 0,
    dropCharge: form.dropCharge || 0,
    useCustomBaseCharge: form.useCustomBaseCharge || false,
    useCustomOtherCharges: form.useCustomOtherCharges || false,
    useCustomFuelSurcharge: form.useCustomFuelSurcharge || false,
    useCustomDropCharge: form.useCustomDropCharge || false,
    // Normalize default leg status casing/format across the app.
    // Leg statuses are stored/compared as lowercase (ex: "pending").
    status: form.status || "pending",
    active: form.active || false,
    parentCompany: form.parentCompany || "",
    author: form.author || null,
    totalCharges: form.totalCharges || 0,
    payoutMileageTotal: form.payoutMileageTotal || 0,
    payoutTotal: form.payoutTotal || null,
    dateCreated: form.dateCreated || new Date(),
    dateUpdated: form.dateUpdated || new Date(),
    // Additional fields
    dropNumber: form.dropNumber || editableLegs.length + 1,
    customer: {
      name: form.customer?.name || "",
      primaryPO: form.customer?.primaryPO || "",
    },
    deliveryAddress: {
      line1: form.deliveryAddress?.line1 || "",
      line2: form.deliveryAddress?.line2 || "",
      city: form.deliveryAddress?.city || "",
      state: form.deliveryAddress?.state || "",
      zip: form.deliveryAddress?.zip || "",
    },
    items: [],
    shipping: {
      primaryShipTicket: form.shipping?.primaryShipTicket || "",
      freightHandlingCode: form.shipping?.freightHandlingCode || "",
    },
    dates: {
      orderDate: form.dates?.orderDate || "",
      orderTime: form.dates?.orderTime || "",
    },
    totals: {
      totalOrderQuantity: form.totals?.totalOrderQuantity || 0,
      totalOrderWeight: form.totals?.totalOrderWeight || 0,
    },
    itemCount: form.itemCount || 0,
    resolvedOriginLocation: form.resolvedOriginLocation || null,
    resolvedLocation: form.resolvedLocation || null,
    totalMiles: form.totalMiles || 0,
    defaultMileage: form.defaultMileage || 0,
    customMileage: form.customMileage || 0,
  };

  return newLeg;
};
